import React, { useState } from 'react';

const Checkout = () => {
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [addressData, setAddressData] = useState({
    firstName: '',
    lastName: '',
    address: '',
    city: '',
    state: '',
    postalCode: '',
    phoneNumber: '',
  });

  const handleAddressChange = (e) => {
    const { name, value } = e.target;
    setAddressData({ ...addressData, [name]: value });
  };

  const handleAddressSubmit = (e) => {
    e.preventDefault();
    console.log(addressData);
    // You can handle further logic here (e.g., save or go back)
  };

  return (
    <>
      <style>{`
        .sidebar-cart {
          width: 350px;
          max-height: 100vh;
          display: flex;
          flex-direction: column;
          background: white;
          border-left: 1px solid #ddd;
          position: fixed;
          top: 0;
          right: 0;
          bottom: 0;
          z-index: 1000;
          box-shadow: -4px 0 15px rgba(0,0,0,0.1);
          padding: 1rem;
          overflow-y: auto;
          font-family: sans-serif;
        }
        .sidebar-cart h2 {
          margin-top: 0;
        }
        .sidebar-cart input,
        .sidebar-cart select {
          width: 100%;
          padding: 8px;
          margin-top: 5px;
          margin-bottom: 10px;
          border: 1px solid #ccc;
          border-radius: 6px;
        }
        .sidebar-cart button {
          background: #2d6a2d;
          color: white;
          border: none;
          padding: 10px;
          font-weight: bold;
          border-radius: 8px;
          cursor: pointer;
        }
        .sidebar-cart button:hover {
          background: #246022;
        }
        .sidebar-cart label {
          font-weight: 600;
          font-size: 0.9rem;
        }
        .sidebar-cart .checkbox-container {
          display: flex;
          align-items: center;
          margin: 10px 0;
        }
        .sidebar-cart .checkbox-container input {
          margin-right: 5px;
        }
      `}</style>

      <div className="sidebar-cart">
        {!showAddressForm ? (
          <>
            <h2>Checkout</h2>
            <p>Here is your checkout UI content...</p>
            <div className="checkbox-container">
              <input
                type="checkbox"
                onChange={(e) => setShowAddressForm(e.target.checked)}
              />
              <label>Add New Address</label>
            </div>
            <button>Proceed to Payment</button>
          </>
        ) : (
          <>
            <h2>Add New Address</h2>
            <form onSubmit={handleAddressSubmit}>
              <label>First Name *</label>
              <input
                type="text"
                name="firstName"
                value={addressData.firstName}
                onChange={handleAddressChange}
                required
              />
              <label>Last Name *</label>
              <input
                type="text"
                name="lastName"
                value={addressData.lastName}
                onChange={handleAddressChange}
                required
              />
              <label>Address *</label>
              <input
                type="text"
                name="address"
                value={addressData.address}
                onChange={handleAddressChange}
                required
              />
              <label>City *</label>
              <input
                type="text"
                name="city"
                value={addressData.city}
                onChange={handleAddressChange}
                required
              />
              <label>State *</label>
              <select
                name="state"
                value={addressData.state}
                onChange={handleAddressChange}
                required
              >
                <option value="">Select State</option>
                <option value="State 1">State 1</option>
                <option value="State 2">State 2</option>
                <option value="State 3">State 3</option>
              </select>
              <label>Postal Code *</label>
              <input
                type="text"
                name="postalCode"
                value={addressData.postalCode}
                onChange={handleAddressChange}
                required
              />
              <label>Phone Number *</label>
              <input
                type="tel"
                name="phoneNumber"
                value={addressData.phoneNumber}
                onChange={handleAddressChange}
                required
              />
              <button type="submit">Save Address</button>
            </form>
          </>
        )}
      </div>
    </>
  );
};

export default Checkout;
